var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wy-page-detail-container" },
    [
      _vm.pageName && !_vm.inDialog
        ? [
            _c("div", { staticClass: "wy-page-name" }, [
              _vm._v(_vm._s(_vm.pageName)),
            ]),
          ]
        : _vm._e(),
      _vm.pageConfig.layout && _vm.displayFields && _vm.displayFields.length
        ? [
            _c(
              "el-form",
              {
                ref: "refForm",
                attrs: {
                  model: _vm.dataForm,
                  rules: _vm.formRules,
                  "label-position": _vm.pageConfig.layout.labelPosition,
                },
              },
              [
                _vm.pageConfig.layout.display == "row"
                  ? [
                      _c(
                        "div",
                        { staticClass: "wy-content-rbox" },
                        _vm._l(_vm.rowCount, function (rowIndex) {
                          return _c(
                            "div",
                            { key: rowIndex, staticClass: "wy-row-box" },
                            [
                              _vm._l(_vm.displayFields, function (item, index) {
                                return index >=
                                  (rowIndex - 1) * _vm.countInRow &&
                                  index < rowIndex * _vm.countInRow
                                  ? [
                                      item.type == "custom"
                                        ? _c(
                                            "el-form-item",
                                            {
                                              key: index,
                                              staticClass: "wy-item-box",
                                              attrs: {
                                                label: item.label,
                                                prop: item.field,
                                                rules: item.required
                                                  ? [
                                                      {
                                                        required: true,
                                                        message:
                                                          item.label +
                                                          "不能为空",
                                                        trigger: "blur change",
                                                      },
                                                    ]
                                                  : item.rules
                                                  ? item.rules
                                                  : [],
                                              },
                                            },
                                            [
                                              _c(item.name, {
                                                tag: "component",
                                                attrs: {
                                                  fieldValue: _vm.dataForm[
                                                    item.field
                                                  ]
                                                    ? _vm.dataForm[item.field]
                                                    : item.defaultValue
                                                    ? item.defaultValue
                                                    : "",
                                                  fieldConfig: item,
                                                },
                                                on: {
                                                  change: _vm.customFieldChange,
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataForm[item.field],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dataForm,
                                                      item.field,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataForm[item.field]",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      item.type == "input" ||
                                      item.type == "number" ||
                                      item.type == "textarea" ||
                                      item.type == "hidden"
                                        ? _c(
                                            "el-form-item",
                                            {
                                              key: index,
                                              staticClass: "wy-item-box",
                                              attrs: {
                                                label: item.label,
                                                prop: item.field,
                                                rules: item.required
                                                  ? [
                                                      {
                                                        required: true,
                                                        message:
                                                          item.label +
                                                          "不能为空",
                                                        trigger: "blur",
                                                      },
                                                    ]
                                                  : item.rules
                                                  ? item.rules
                                                  : [],
                                              },
                                            },
                                            [
                                              item.type == "input"
                                                ? _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        placeholder:
                                                          item.placeholder
                                                            ? item.placeholder
                                                            : "请输入" +
                                                              item.label,
                                                        clearable: "",
                                                        disabled: item.disabled
                                                          ? item.disabled
                                                          : false,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return _vm.inputEvent(
                                                            item
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dataForm[
                                                            item.field
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dataForm,
                                                            item.field,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dataForm[item.field]",
                                                      },
                                                    },
                                                    [
                                                      item.append
                                                        ? _c(
                                                            "template",
                                                            { slot: "append" },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.append
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  )
                                                : item.type == "number"
                                                ? _c("el-input-number", {
                                                    attrs: {
                                                      min: 1,
                                                      max: 999999,
                                                      disabled: item.disabled
                                                        ? item.disabled
                                                        : false,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.dataForm[
                                                          item.field
                                                        ],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.dataForm,
                                                          item.field,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "dataForm[item.field]",
                                                    },
                                                  })
                                                : item.type == "hidden"
                                                ? _c("el-input", {
                                                    attrs: { type: "hidden" },
                                                    model: {
                                                      value:
                                                        _vm.dataForm[
                                                          item.field
                                                        ],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.dataForm,
                                                          item.field,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "dataForm[item.field]",
                                                    },
                                                  })
                                                : _c("el-input", {
                                                    attrs: {
                                                      type: "textarea",
                                                      rows: item.rows
                                                        ? item.rows
                                                        : 5,
                                                      placeholder:
                                                        item.placeholder
                                                          ? item.placeholder
                                                          : "请输入" +
                                                            item.label,
                                                      disabled: item.disabled
                                                        ? item.disabled
                                                        : false,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.dataForm[
                                                          item.field
                                                        ],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.dataForm,
                                                          item.field,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "dataForm[item.field]",
                                                    },
                                                  }),
                                              item.tips
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "item-tips",
                                                    },
                                                    [_vm._v(_vm._s(item.tips))]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : item.type == "select" ||
                                          item.type == "date" ||
                                          item.type == "checkbox" ||
                                          item.type == "radio"
                                        ? _c(
                                            "el-form-item",
                                            {
                                              key: index,
                                              staticClass: "wy-item-box",
                                              attrs: {
                                                label: item.label,
                                                prop: item.field,
                                                rules: item.required
                                                  ? [
                                                      {
                                                        required: true,
                                                        message:
                                                          item.label +
                                                          "不能为空",
                                                        trigger: "change",
                                                      },
                                                    ]
                                                  : item.rules
                                                  ? item.rules
                                                  : [],
                                              },
                                            },
                                            [
                                              item.type == "select"
                                                ? _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        placeholder:
                                                          item.placeholder
                                                            ? item.placeholder
                                                            : "请选择" +
                                                              item.label,
                                                        multiple: item.multiple
                                                          ? item.multiple
                                                          : false,
                                                        clearable: "",
                                                        filterable: "",
                                                        disabled: item.disabled
                                                          ? item.disabled
                                                          : false,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dataForm[
                                                            item.field
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dataForm,
                                                            item.field,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dataForm[item.field]",
                                                      },
                                                    },
                                                    _vm._l(
                                                      item.options,
                                                      function (opItem) {
                                                        return _c("el-option", {
                                                          key:
                                                            opItem.label +
                                                            opItem.value,
                                                          attrs: {
                                                            label: opItem.label,
                                                            value: opItem.value,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : item.type == "date"
                                                ? _c("el-date-picker", {
                                                    attrs: {
                                                      type: "date",
                                                      "value-format":
                                                        "yyyy-MM-dd",
                                                      placeholder: "选择日期",
                                                      disabled: item.disabled
                                                        ? item.disabled
                                                        : false,
                                                      "picker-options":
                                                        _vm.datepickerOptions[
                                                          item.field
                                                        ],
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.dataForm[
                                                          item.field
                                                        ],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.dataForm,
                                                          item.field,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "dataForm[item.field]",
                                                    },
                                                  })
                                                : item.type == "checkbox"
                                                ? _c(
                                                    "el-checkbox-group",
                                                    {
                                                      attrs: {
                                                        disabled: item.disabled
                                                          ? item.disabled
                                                          : false,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dataForm[
                                                            item.field
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dataForm,
                                                            item.field,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dataForm[item.field]",
                                                      },
                                                    },
                                                    _vm._l(
                                                      item.options,
                                                      function (
                                                        optItem,
                                                        optIndex
                                                      ) {
                                                        return _c(
                                                          "el-checkbox",
                                                          {
                                                            key: optIndex,
                                                            attrs: {
                                                              label:
                                                                optItem.value,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                optItem.label
                                                              ) +
                                                                "\n                                    "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _vm._e(),
                                              item.type == "radio"
                                                ? _c(
                                                    "el-radio-group",
                                                    {
                                                      attrs: {
                                                        disabled: item.disabled
                                                          ? item.disabled
                                                          : false,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dataForm[
                                                            item.field
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dataForm,
                                                            item.field,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dataForm[item.field]",
                                                      },
                                                    },
                                                    _vm._l(
                                                      item.options,
                                                      function (
                                                        optItem,
                                                        optIndex
                                                      ) {
                                                        return _c(
                                                          "el-radio",
                                                          {
                                                            key: optIndex,
                                                            attrs: {
                                                              label:
                                                                optItem.value,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                optItem.label
                                                              ) +
                                                                "\n                                    "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _vm._e(),
                                              item.tips
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "item-tips",
                                                    },
                                                    [_vm._v(_vm._s(item.tips))]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : item.type == "uploadImg"
                                        ? _c(
                                            "el-form-item",
                                            {
                                              key: index,
                                              staticClass: "wy-item-box",
                                              attrs: {
                                                label: item.label,
                                                prop: item.field,
                                                rules: item.required
                                                  ? [
                                                      {
                                                        required: true,
                                                        message: "请上传图片",
                                                        trigger: "change",
                                                      },
                                                    ]
                                                  : item.rules
                                                  ? item.rules
                                                  : [],
                                              },
                                            },
                                            [
                                              _c("wy-upload-multi-img", {
                                                attrs: {
                                                  title: "",
                                                  "upload-api":
                                                    _vm.global.getUploadApi(),
                                                  headers:
                                                    _vm.global.getUploadHeaders(),
                                                  "inner-style":
                                                    "font-size: inherit;width: auto;",
                                                  accept:
                                                    ".jpg,.jpeg,.png,.gif",
                                                  "arrage-type": "row",
                                                  "show-type-tips": false,
                                                  limit: item.limit
                                                    ? item.limit
                                                    : 3,
                                                },
                                                on: {
                                                  change: _vm.uploadImgChange,
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataForm[item.field],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dataForm,
                                                      item.field,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataForm[item.field]",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : item.type == "label"
                                        ? _c(
                                            "el-form-item",
                                            {
                                              key: index,
                                              staticClass:
                                                "wy-item-box show-item",
                                              attrs: {
                                                label: item.label,
                                                prop: item.field,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  style: item.style
                                                    ? item.style
                                                    : "",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.dataForm[item.field]
                                                    )
                                                  ),
                                                  item.append
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item.append)
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          )
                                        : item.type == "json"
                                        ? _c(
                                            "el-form-item",
                                            {
                                              key: index,
                                              staticClass:
                                                "wy-item-box show-item json-item",
                                              attrs: {
                                                label: item.label,
                                                prop: item.field,
                                              },
                                            },
                                            [
                                              _c("pre", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.callDynamicMethod(
                                                      item.formatFn,
                                                      _vm.dataForm[item.field]
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e()
                              }),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                    ]
                  : _vm._e(),
                _vm.pageConfig.layout.display == "column"
                  ? [
                      _c(
                        "div",
                        { staticClass: "wy-content-cbox" },
                        _vm._l(_vm.columnCount, function (colIndex) {
                          return _c(
                            "div",
                            { key: colIndex, staticClass: "wy-column-box" },
                            [
                              _vm._l(_vm.displayFields, function (item, index) {
                                return index >=
                                  (colIndex - 1) * _vm.countIncolumn &&
                                  index < colIndex * _vm.countIncolumn
                                  ? [
                                      item.type == "custom"
                                        ? _c(
                                            "el-form-item",
                                            {
                                              key: index,
                                              staticClass: "wy-item-box",
                                              attrs: {
                                                label: item.label,
                                                prop: item.field,
                                                rules: item.required
                                                  ? [
                                                      {
                                                        required: true,
                                                        message:
                                                          item.label +
                                                          "不能为空",
                                                        trigger: "blur change",
                                                      },
                                                    ]
                                                  : item.rules
                                                  ? item.rules
                                                  : [],
                                              },
                                            },
                                            [
                                              _c(item.name, {
                                                tag: "component",
                                                attrs: {
                                                  fieldValue: _vm.dataForm[
                                                    item.field
                                                  ]
                                                    ? _vm.dataForm[item.field]
                                                    : item.defaultValue
                                                    ? item.defaultValue
                                                    : "",
                                                  fieldConfig: item,
                                                },
                                                on: {
                                                  change: _vm.customFieldChange,
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataForm[item.field],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dataForm,
                                                      item.field,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataForm[item.field]",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      item.type == "input" ||
                                      item.type == "number" ||
                                      item.type == "textarea" ||
                                      item.type == "hidden"
                                        ? _c(
                                            "el-form-item",
                                            {
                                              key: index,
                                              staticClass: "wy-item-box",
                                              attrs: {
                                                label: item.label,
                                                prop: item.field,
                                                rules: item.required
                                                  ? [
                                                      {
                                                        required: true,
                                                        message:
                                                          item.label +
                                                          "不能为空",
                                                        trigger: "blur",
                                                      },
                                                    ]
                                                  : item.rules
                                                  ? item.rules
                                                  : [],
                                              },
                                            },
                                            [
                                              item.type == "input"
                                                ? _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        placeholder:
                                                          item.placeholder
                                                            ? item.placeholder
                                                            : "请输入" +
                                                              item.label,
                                                        clearable: "",
                                                        disabled: item.disabled
                                                          ? item.disabled
                                                          : false,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return _vm.inputEvent(
                                                            $event,
                                                            item
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dataForm[
                                                            item.field
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dataForm,
                                                            item.field,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dataForm[item.field]",
                                                      },
                                                    },
                                                    [
                                                      item.append
                                                        ? _c(
                                                            "template",
                                                            { slot: "append" },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.append
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  )
                                                : item.type == "number"
                                                ? _c("el-input-number", {
                                                    attrs: {
                                                      min: 1,
                                                      max: 999999,
                                                      disabled: item.disabled
                                                        ? item.disabled
                                                        : false,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.dataForm[
                                                          item.field
                                                        ],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.dataForm,
                                                          item.field,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "dataForm[item.field]",
                                                    },
                                                  })
                                                : item.type == "hidden"
                                                ? _c("el-input", {
                                                    attrs: { type: "hidden" },
                                                    model: {
                                                      value:
                                                        _vm.dataForm[
                                                          item.field
                                                        ],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.dataForm,
                                                          item.field,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "dataForm[item.field]",
                                                    },
                                                  })
                                                : _c("el-input", {
                                                    attrs: {
                                                      type: "textarea",
                                                      rows: item.rows
                                                        ? item.rows
                                                        : 5,
                                                      disabled: item.disabled
                                                        ? item.disabled
                                                        : false,
                                                      placeholder:
                                                        item.placeholder
                                                          ? item.placeholder
                                                          : "请输入" +
                                                            item.label,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.dataForm[
                                                          item.field
                                                        ],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.dataForm,
                                                          item.field,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "dataForm[item.field]",
                                                    },
                                                  }),
                                              item.tips
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "item-tips",
                                                    },
                                                    [_vm._v(_vm._s(item.tips))]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : item.type == "select" ||
                                          item.type == "date" ||
                                          item.type == "checkbox" ||
                                          item.type == "radio"
                                        ? _c(
                                            "el-form-item",
                                            {
                                              key: index,
                                              staticClass: "wy-item-box",
                                              attrs: {
                                                label: item.label,
                                                prop: item.field,
                                                rules: item.required
                                                  ? [
                                                      {
                                                        required: true,
                                                        message:
                                                          item.label +
                                                          "不能为空",
                                                        trigger: "change",
                                                      },
                                                    ]
                                                  : item.rules
                                                  ? item.rules
                                                  : [],
                                              },
                                            },
                                            [
                                              item.type == "select"
                                                ? _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        placeholder:
                                                          item.placeholder
                                                            ? item.placeholder
                                                            : "请选择" +
                                                              item.label,
                                                        multiple: item.multiple
                                                          ? item.multiple
                                                          : false,
                                                        clearable: "",
                                                        filterable: "",
                                                        disabled: item.disabled
                                                          ? item.disabled
                                                          : false,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dataForm[
                                                            item.field
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dataForm,
                                                            item.field,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dataForm[item.field]",
                                                      },
                                                    },
                                                    _vm._l(
                                                      item.options,
                                                      function (opItem) {
                                                        return _c("el-option", {
                                                          key:
                                                            opItem.label +
                                                            opItem.value,
                                                          attrs: {
                                                            label: opItem.label,
                                                            value: opItem.value,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : item.type == "date"
                                                ? _c("el-date-picker", {
                                                    attrs: {
                                                      type: "date",
                                                      "value-format":
                                                        "yyyy-MM-dd",
                                                      "picker-options":
                                                        _vm.datepickerOptions[
                                                          item.field
                                                        ],
                                                      placeholder: "选择日期",
                                                      disabled: item.disabled
                                                        ? item.disabled
                                                        : false,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.dataForm[
                                                          item.field
                                                        ],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.dataForm,
                                                          item.field,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "dataForm[item.field]",
                                                    },
                                                  })
                                                : item.type == "checkbox"
                                                ? _c(
                                                    "el-checkbox-group",
                                                    {
                                                      attrs: {
                                                        disabled: item.disabled
                                                          ? item.disabled
                                                          : false,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dataForm[
                                                            item.field
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dataForm,
                                                            item.field,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dataForm[item.field]",
                                                      },
                                                    },
                                                    _vm._l(
                                                      item.options,
                                                      function (
                                                        optItem,
                                                        optIndex
                                                      ) {
                                                        return _c(
                                                          "el-checkbox",
                                                          {
                                                            key: optIndex,
                                                            attrs: {
                                                              label:
                                                                optItem.value,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                optItem.label
                                                              ) +
                                                                "\n                                    "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _vm._e(),
                                              item.type == "radio"
                                                ? _c(
                                                    "el-radio-group",
                                                    {
                                                      attrs: {
                                                        disabled: item.disabled
                                                          ? item.disabled
                                                          : false,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dataForm[
                                                            item.field
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dataForm,
                                                            item.field,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dataForm[item.field]",
                                                      },
                                                    },
                                                    _vm._l(
                                                      item.options,
                                                      function (
                                                        optItem,
                                                        optIndex
                                                      ) {
                                                        return _c(
                                                          "el-radio",
                                                          {
                                                            key: optIndex,
                                                            attrs: {
                                                              label:
                                                                optItem.value,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                optItem.label
                                                              ) +
                                                                "\n                                    "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _vm._e(),
                                              item.tips
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "item-tips",
                                                    },
                                                    [_vm._v(_vm._s(item.tips))]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : item.type == "uploadImg"
                                        ? _c(
                                            "el-form-item",
                                            {
                                              key: index,
                                              staticClass: "wy-item-box",
                                              attrs: {
                                                label: item.label,
                                                prop: item.field,
                                                rules: item.required
                                                  ? [
                                                      {
                                                        required: true,
                                                        message: "请上传图片",
                                                        trigger: "change",
                                                      },
                                                    ]
                                                  : item.rules
                                                  ? item.rules
                                                  : [],
                                              },
                                            },
                                            [
                                              _c("wy-upload-multi-img", {
                                                attrs: {
                                                  title: "",
                                                  "upload-api":
                                                    _vm.global.getUploadApi(),
                                                  headers:
                                                    _vm.global.getUploadHeaders(),
                                                  "inner-style":
                                                    "font-size: inherit;width: auto;",
                                                  accept:
                                                    ".jpg,.jpeg,.png,.gif",
                                                  "arrage-type": "row",
                                                  "show-type-tips": false,
                                                  limit: item.limit
                                                    ? item.limit
                                                    : 3,
                                                },
                                                on: {
                                                  change: _vm.uploadImgChange,
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataForm[item.field],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dataForm,
                                                      item.field,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataForm[item.field]",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : item.type == "label"
                                        ? _c(
                                            "el-form-item",
                                            {
                                              key: index,
                                              staticClass:
                                                "wy-item-box show-item",
                                              attrs: {
                                                label: item.label,
                                                prop: item.field,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  style: item.style
                                                    ? item.style
                                                    : "",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.dataForm[item.field]
                                                    )
                                                  ),
                                                  item.append
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item.append)
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          )
                                        : item.type == "json"
                                        ? _c(
                                            "el-form-item",
                                            {
                                              key: index,
                                              staticClass:
                                                "wy-item-box show-item json-item",
                                              attrs: {
                                                label: item.label,
                                                prop: item.field,
                                              },
                                            },
                                            [
                                              _c("pre", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.callDynamicMethod(
                                                      item.formatFn,
                                                      _vm.dataForm[item.field]
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e()
                              }),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        : _vm._e(),
      _vm.pageConfig.buttons && _vm.pageConfig.buttons.length
        ? [
            _c(
              "div",
              { staticClass: "wy-btn-box" },
              [
                _vm._l(
                  _vm.pageConfig.buttons,
                  function (buttonItem, buttonIndex) {
                    return [
                      _c(
                        buttonItem.permissionID
                          ? "wy-permission-button"
                          : "el-button",
                        {
                          key: buttonItem.label + buttonIndex,
                          tag: "component",
                          attrs: {
                            pID: buttonItem.permissionID
                              ? buttonItem.permissionID
                              : "",
                            type: buttonItem.type ? buttonItem.type : "primary",
                            loading: buttonItem.loading
                              ? _vm.actionLoading
                              : false,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.buttonClickEvent(buttonItem)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(buttonItem.label) +
                              "\n                "
                          ),
                        ]
                      ),
                    ]
                  }
                ),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }